import { Avatar, Popover } from "antd";

type Props = {
  data: any;
};

const AvatarGroupTable = ({ data }: Props) => {
  console.log(data?.team_members);

  const content = (
    <div className="px-4 py-3 flex flex-col gap-3">
      <h5 className="text-color-primary text-sm font-semibold mb-3">
        Service providers
      </h5>
      {data?.team_members?.map((e: any) => (
        <div className="flex items-center gap-2">
          <img
            className="w-6 h-6 rounded-full object-cover"
            src={e?.media}
            alt=""
          />
          <span className="text-[#020418] text-sm font-medium">{e?.name}</span>
          <span className="text-[#75757E] text-sm font-medium">{e?.title}</span>
        </div>
      ))}
    </div>
  );
  return (
    <Avatar.Group className="">
      <Popover
        placement="top"
        title={false}
        content={content}
        className="w-[110px] h-[25px] overflow-hidden"
      >
        {data?.team_members?.map((e: any) => (
          <img
            className="w-6 h-6 rounded-full mx-1 object-cover"
            src={e?.media}
            alt=""
          />
        ))}
      </Popover>
    </Avatar.Group>
  );
};

export default AvatarGroupTable;
